import { createFileRoute } from '@tanstack/react-router'
import { AdminPayrollTable } from '@/common/components/admin-payroll-table/AdminPayrollTable'

export const Route = createFileRoute('/org/')({
  component: AdminPayrollTable,
})
